<template>
    <div>
        <div class="popup__content">
            <div class="text-size-l text-bold text-color mb24">Раздел</div>
            <div style=" width: 100%;">
                <input-styled
                :auto-focus="true"
                name="section-name"
                :placeholder="'Название'"
                :placeholderInput="'Название'"
                @enter="send"
                v-model="form.category.text"
                @focus="form.category.error=false"
                :is-error="form.category.error">
                </input-styled>
            </div>
            <div class="row-b mt24">
                <div class="row-b__col elem-pos-fix mr24">
                    <submit-btn class="" @click.native="send" :type="form.btnType">
                        <span v-if="form.btnType=='normal'" class="i i-ok7 mr8"></span>Сохранить
                    </submit-btn>
                </div>
            </div>
            <div v-if="section.id" class="remove-rule" @click="removeTopCat" >
                <a href="javascript:void(0);" class="link-icon link-icon__modal">
                    <span class="i i-trash2"></span>
                    <span class="text">Удалить раздел</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InputStyled from '@/components/forms/InputStyled.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "SectionAdd",
        components: {
            InputStyled,
            SubmitBtn
        },
        mounted(){
            //if(this.section && this.section.length>0){
                this.form.category.text = this.section.name;
            //}
        },
        data() {
            return {
                form:{
                    category: {
                        text: '',
                        error: false,
                    },
                    btnType: 'normal'
                },
            }
        },
        methods: {
            removeTopCat: function(){
                this.$store.dispatch('rules/removeTopSection', {
                id: this.section.id,
                }).then(result => {
                    this.$store.commit('popups/close', {name: this.popups.sectionAdd.name});
                    if(result){
                        if(this.activeTopSection == this.section.id){
                            this.$router.push('/sid'+this.topSections[0].id+'/');
                        }
                    }
                    else{
                        this.openRemoveCatError();
                    }
                });
            },
            openRemoveCatError: function () {
                //this.$store.commit('popups/close', {name: this.popups.ruleCategory.name});
                this.$store.commit('popups/open', {name: this.popups.sectionRemoveError.name});
            },
            send(){
                let error = false;
                if(!this.form.category.text || this.form.category.text.length == 0){
                    if(this.form.category.error){
                        this.form.category.error = false;
                        setTimeout(() => {
                            this.form.category.error = true;
                        }, 10);
                    }else{
                        this.form.category.error = true;
                    }
                    error = true;
                }
                if(!error){
                    this.form.btnType = 'load';
                    this.$store.dispatch('rules/setSection', {
                        name: this.form.category.text,
                        id: this.section.id ? this.section.id : false,
                        //topSection: this.activeTopSection,
                        isTop: true,
                    }).then((data)=>{
                        this.form.btnType = 'normal';
                        this.$store.commit('popups/close', {name: this.popups.sectionAdd.name});
                        setTimeout(()=>{
                          if (data.error === 403) {
                              this.$store.commit('popups/open', {name: this.popups.sectionForbiddenError.name});
                            } // На всякий случай очистим данные для редактирования раздела
                            if(data.id && !this.section.id){
                                this.$router.push({path: '/sid'+data.id});
                            }
                            this.$store.commit('rules/setEditSection',[]);
                        }, 100);
                    });
                }
            },
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                section: state => state.rules.editSection,
                sections: state => state.rules.sections,
                topSections: state => state.rules.topSections,
            }),
            activeSection(){
                return this.$route.params.subid ? this.$route.params.subid : this.sections[0].id;
            },
            activeTopSection(){
                //if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        },
    }
</script>

<style scoped>

</style>
